import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SFacebookMessenger component used for FacebookMessenger social network
 * @link https://facebook.com/
 * @example https://www.facebook.com/dialog/send?link=https%3A%2F%2Fgithub.com%2F&app_id=123456789&redirect_uri=https%3A%2F%2Fwww.domain.com%2F
 */
/**
 * Share parameters for link
 * @link https://developers.facebook.com/docs/sharing/reference/send-dialog#examples
 * url => link
 * appId => app_id
 * redirectUri => redirect_uri
 */

var SFacebookMessenger = /* #__PURE__ */defineComponent({
  name: 'SFacebookMessenger',
  mixins: [BaseSocials('Facebook Messenger')],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'http://www.facebook.com/dialog/send';
      var shareOptions = this.shareOptions;
      var url = shareOptions.url,
          appId = shareOptions.appId,
          redirectUri = shareOptions.redirectUri,
          to = shareOptions.to;
      var serialisedParams = getSerialisedParams({
        link: url,
        app_id: appId,
        redirect_uri: redirectUri,
        to: to
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SFacebookMessenger;
